<app-select-filter [parentFormGroup]="parentFormGroup"
                   noEntriesFoundLabel="Aucun élément trouvé"
                   [parentFormControlName]="parentFormControlName"
                   [elements]="formats"
                   [filterElementProcessor]="filterFormats">
  <ng-template template-content let-element='element'>
    {{element[0].toUpperCase() + element.slice(1).toLowerCase()}}
  </ng-template>
</app-select-filter>